import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "./Admin.css";
import { useTranslation } from "react-i18next";
import OrderDetails from "./OrderDetails/OrderDetails";
import OrderGrid from "./OrderGrid/OrderGrid";
import { useDispatch } from "react-redux";
import { sagaActions } from "../../redux/sagas/sagaActions";
import { getLocalStorage, setLocalStorage } from "../../helper/Storage";

const Admin = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const [orders, setOrders] = useState(getLocalStorage("orders") ?? []);
  const [open, setOpen] = useState(false);
  const [selectedOrderNo, setSelectedOrderNo] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = (orderNo) => {
    setSelectedOrderNo(orderNo);
    setOpen(true);
  };

  const increaseQuantity = (itemId, order) => {
    let item = order.items.filter((item) => item.id === itemId)[0];
    item = { ...item, count: Number(item.count) + 1 };
    let updatedOrder = { ...order };
    updatedOrder.items = [
      ...order.items.filter((item) => item.id !== itemId),
      ...[item],
    ];
    const updatedOrders = [
      ...orders?.filter((ord) => ord.orderNo !== selectedOrderNo),
      ...[updatedOrder],
    ];
    setOrders(updatedOrders);
    setLocalStorage("orders", updatedOrders);
  };

  const decreaseQuantity = (itemId, order) => {
    let item = order.items.filter((item) => item.id === itemId)[0];
    let updatedOrder = { ...order };
    if (item.count <= 1) {
      updatedOrder.items = [
        ...order.items.filter((item) => item.id !== itemId),
      ];
    } else {
      item = { ...item, count: Number(item.count) - 1 };
      updatedOrder.items = [
        ...order.items.filter((item) => item.id !== itemId),
        ...[item],
      ];
    }
    let updatedOrders = [
      ...orders?.filter((ord) => ord.orderNo !== selectedOrderNo),
    ];

    if (updatedOrder.items.length > 0) {
      updatedOrders = [...updatedOrders, ...[updatedOrder]];
    }

    setOrders(updatedOrders);
    setLocalStorage("orders", updatedOrders);
  };

  const deleteOrder = (orderNo) => {
    let updatedOrders = [...orders?.filter((ord) => ord.orderNo !== orderNo)];

    setOrders(updatedOrders);
    setLocalStorage("orders", updatedOrders);
  };

  const markPaid = (order) => {
    let updatedOrder = { ...order, status: "PAID" };
    let updatedOrders = [
      ...orders?.filter((ord) => ord.orderNo !== order.orderNo),
      ...[updatedOrder],
    ];
    setOrders(updatedOrders);
    setLocalStorage("orders", updatedOrders);
  };

  const updateAddress = (
    order,
    fullName,
    phoneNumber,
    address,
    deliveryFee,
  ) => {
    let updatedOrder = {
      ...order,
      customerName: fullName,
      phone: phoneNumber,
      address,
      deliveryFee: Number(deliveryFee),
    };
    let updatedOrders = [
      ...orders?.filter((ord) => ord.orderNo !== order.orderNo),
      ...[updatedOrder],
    ];
    setOrders(updatedOrders);
    setLocalStorage("orders", updatedOrders);
  };

  useEffect(() => {
    dispatch({ type: sagaActions.SPICES_LOAD_REQUEST });
    dispatch({ type: sagaActions.INCENSES_LOAD_REQUEST });
    dispatch({ type: sagaActions.CONTACTS_LOAD_REQUEST });
  }, [dispatch]);

  return (
    <Box sx={{ padding: "15px", textAlign: "left" }}>
      <Typography
        variant="h4"
        sx={{
          borderBottom: 1,
          textAlign: "center",
          padding: "10px 0",
          borderColor: "#abababcc",
        }}
      >
        {t("admin.header")}
      </Typography>
      <OrderGrid
        handleOpen={handleOpen}
        orders={orders}
        setOrders={setOrders}
      ></OrderGrid>
      {selectedOrderNo && (
        <OrderDetails
          open={open}
          handleClose={handleClose}
          order={orders?.filter((ord) => ord.orderNo === selectedOrderNo)[0]}
          increaseQuantity={increaseQuantity}
          decreaseQuantity={decreaseQuantity}
          deleteOrder={deleteOrder}
          markPaid={markPaid}
          updateAddress={updateAddress}
        ></OrderDetails>
      )}
    </Box>
  );
};

export default Admin;
